/**
 * RK Cart Drawer – Lieferdatum, 1-Klick-Empfehlungen und Aktualisierung der rk-Bereiche
 */
(function () {
  if (window.RkCartDrawer) return;
  window.RkCartDrawer = true;

  const WEEKDAYS = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

  function getDaysAfterToday() {
    const check = new Date();
    check.setDate(check.getDate() + 2);
    return check.getDay() === 0 ? 3 : 2;
  }

  function formatShortDate(date) {
    return `${WEEKDAYS[date.getDay()]}. ${date.getDate()}.${date.getMonth() + 1}.`;
  }

  function initDeliveryEstimate(drawer) {
    const rangeEl = drawer?.querySelector('[data-delivery-range]');
    if (!rangeEl) return;

    const from = new Date();
    from.setDate(from.getDate() + getDaysAfterToday());
    const to = new Date(from);
    to.setDate(to.getDate() + 1);

    rangeEl.textContent = `${formatShortDate(from)} – ${formatShortDate(to)}`;
  }

  function showError(drawer, message) {
    const errors = drawer?.querySelector('#CartDrawer-CartErrors');
    if (errors) errors.textContent = message || '';
  }

  async function addUpsell(btn) {
    const variantId = parseInt(btn.dataset.variantId, 10);
    const cartDrawer = document.querySelector('cart-drawer');
    if (!variantId || !cartDrawer || btn.getAttribute('aria-busy') === 'true') return;

    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    showError(cartDrawer, '');

    try {
      const response = await fetch(window.routes.cart_add_url, {
        ...fetchConfig(),
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: cartDrawer.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();

      if (data.status) {
        showError(cartDrawer, data.description || data.message);
        btn.disabled = false;
        return;
      }

      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rk-cart-drawer', cartData: data });
      cartDrawer.classList.remove('is-empty');
      cartDrawer.renderContents(data);
    } catch (error) {
      console.error(error);
      btn.disabled = false;
    } finally {
      btn.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('cart-drawer [data-upsell-add]');
    if (btn) addUpsell(btn);
  });

  function patchCartDrawer() {
    const proto = customElements.get('cart-drawer')?.prototype;
    if (!proto || proto._rkPatched) return;

    const originalOpen = proto.open;
    proto.open = function (...args) {
      originalOpen.apply(this, args);
      initDeliveryEstimate(this);
    };

    const originalRenderContents = proto.renderContents;
    proto.renderContents = function (...args) {
      originalRenderContents.apply(this, args);
      initDeliveryEstimate(this);
    };

    proto._rkPatched = true;
  }

  function patchCartDrawerItems() {
    const proto = customElements.get('cart-drawer-items')?.prototype;
    if (!proto || proto._rkPatched) return;

    proto.onCartUpdate = function () {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = [
            '.rk-cart-drawer__inner > .rk-cart-drawer__header',
            '.rk-cart-drawer__shipping',
            'cart-drawer-items',
            '.rk-cart-drawer__recommendations',
            '.rk-cart-drawer__footer',
          ];
          for (const selector of selectors) {
            const target = document.querySelector(selector);
            const source = html.querySelector(selector);
            if (target && source) target.replaceWith(source);
          }
          initDeliveryEstimate(document.querySelector('cart-drawer'));
        })
        .catch((error) => console.error(error));
    };

    proto._rkPatched = true;
  }

  function init() {
    patchCartDrawer();
    patchCartDrawerItems();
    initDeliveryEstimate(document.querySelector('cart-drawer'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
